import { getData } from '../utils/data'

/**
 * Modal controls.
 */
export default function modalSection () {
  const html = document.getElementsByTagName('html')[0],
    modal = document.getElementById('modal')
  if (modal) {
    const iframe = modal.querySelector('iframe'),
      toggler = getData(document.getElementById('modal'), 'toggler')

    if (toggler) {

      iframe.addEventListener('load', function () {
        try {
          const href = $iframe[0].contentWindow.location.href
          toggler.toggle(href !== 'about:blank')
        } catch (e) {
          toggler.close()
        }
      })

      modal.addEventListener('click', event => {
        if (event.target === modal) toggler.close()
      })

      toggler.on('toggle', _ => {
        html.classList[toggler.isOpen ? 'add' : 'remove']('is-modal-open')
      })
    }
  }
}



// WEBPACK FOOTER //
// ./source/scripts/sections/modal.js